module.exports = __webpack_public_path__ + "static/media/restaurant4.d0a6e68e.jpg";